import workspaceQuery from 'graphql/queries/product/ProductsStockTransferReasonWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/product/ProductsStockTransferReasonListQuery.graphql';
import instanceQuery from 'graphql/queries/product/ProductsStockTransferReasonQuery.graphql';
import defaultQuery from 'graphql/queries/product/ProductsStockTransferReasonDefault.graphql';
import mutationQuery from 'graphql/mutations/product/ProductsStockTransferReasonMutation.graphql';
import fragment from 'graphql/fragments/product/ProductsStockTransferReasonFragment.graphql';

const StockTransferReason = {
  type: 'StockTransferReason',
  title: 'Stock Transfer Reasons',
  formTitle: 'Stock Transfer Reason',
  formUrl: '/Products/StockControl/StockTransferReason/Details/',
  workspaceUrl: '/Products/StockControl/StockTransferReason/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'PRODUCTS_STOCK_CONTROL_STOCK_TRANSFER_REASONS',
};

export default StockTransferReason;
